import { PrismicVideo } from './PrismicTypes';
export const GENERIC_VIDEO = 'PrismicGenericTemplateDataBodyVideoComponent';

export interface GenericVideoPrimary {
  video?: PrismicVideo;
  size: 'md' | 'lg' | 'full';
}

export interface GenericVideoContent {
  __typename: typeof GENERIC_VIDEO;
  primary: GenericVideoPrimary;
}
